import React, { useRef, useEffect } from 'react'
import style from './index.module.less'
import { Link } from "gatsby"
import { useIntl } from "react-intl";
import classNames from 'classnames'
import { XrealLogoBlack, ShopIconWhite, XrealLogoWhite } from "@/images/index"
import ArrowRight from '@/images/SVG/arrow-right.svg'
const MobileFirstMenu = ({ 
  handleShowSecondMenu, 
  ifSubMenuShow, 
  setIfSubMenuShow, 
  getLinkUrl, 
  shopUrl, 
  dontfixed, 
  guidesList, 
  ifShowLocalNav,
  cusBackgroundColor = 'rgba(255,255,255,1)',
  cusBackdropFilter = 40,
  headerTextBlack
}) => {
  const headerRef = useRef()
  const menuRef = useRef()
  const intl = useIntl()

  useEffect(() => {
    if(!ifShowLocalNav) return

    document.body.style.overflow = 'auto'
    window.addEventListener("scroll", handleScroll)
    return () => {
        window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  let lastScrollTop = 0;
  const handleScroll = () => {
    const currentScrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    const scrollDistance = currentScrollTop - lastScrollTop
    lastScrollTop = currentScrollTop;
    const whentohide = 200
    if (scrollDistance > 0 && currentScrollTop >= whentohide) {
      menuRef.current.style.opacity = '0'
      headerRef.current.style.transform = `translateY(-100%)`
    } else if ((currentScrollTop < whentohide) || !dontfixed) {
      menuRef.current.style.opacity = '1'
      headerRef.current.style.transform = `translateY(0)`
    }
  }

  const isHeaderLogoBlack = headerTextBlack || ifSubMenuShow

  return (
    <div className={style.menu}
      style={{ 
        position: dontfixed ? "absolute" : "fixed",
        backgroundColor: ifSubMenuShow ? 'rgba(245, 245, 245, 1)' : cusBackgroundColor,
        backdropFilter: `blur(${cusBackdropFilter})`
       }} 
      ref={headerRef}>
      <div>
        <div className={style.menuM} ref={menuRef}>
          <div className={style.menuMLeft}>
            <div className={classNames(style.menuMBtn, ifSubMenuShow && style.menuMBtnClose)}
              onClick={() => {
                setIfSubMenuShow(!ifSubMenuShow)
              }}
            >
              <div className={classNames(style.menuMBtnItem, style.menuMBtnItem1)}></div>
              <div className={classNames(style.menuMBtnItem, style.menuMBtnItem2)}></div>
              <div className={classNames(style.menuMBtnItem, style.menuMBtnItem3)}></div>
            </div>

            <Link to={getLinkUrl("/")} className={style.menuLogo}>
              {isHeaderLogoBlack ? <XrealLogoBlack /> : <XrealLogoWhite />}
            </Link>

          </div>
      
          <a href={shopUrl} target='_blank' className={style.shop}>
            <ShopIconWhite className={style.shopIcon} />
            <div>{intl.formatMessage({ id: "headernew_shop" })}</div>
          </a>
        </div>
        
      </div>

      <div className={style.guidesList} style={{ height: ifSubMenuShow ? 'calc(100vh - 48px)' : '0', opacity: ifSubMenuShow ? '1' : '0'}}>
        <div>
          {guidesList.map((gItem) => (
            (gItem.link ? 
              <Link to={gItem.link} key={gItem.id}>
                <div className={style.guidesItem}>
                  <div>{gItem.title}</div>
                  <ArrowRight className={style.arrowRight} />
                </div>
              </Link> : 
              <div className={style.guidesItem} key={gItem.id}
                onClick={() => handleShowSecondMenu(gItem.title, gItem.key)}
              >
                <div>{gItem.title}</div>
                <ArrowRight className={style.arrowRight} />
              </div>
            )
          ))}
          
        </div>
      </div>
    </div>
  )
}

export default MobileFirstMenu
